"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const of_1 = require("rxjs/observable/of");
const page_filter_component_1 = require("../page-filter.component");
const page_filter_builder_component_1 = require("../builder/page-filter-builder.component");
const page_filter_state_1 = require("../model/page-filter-state");
const page_filter_helper_1 = require("../helper/page-filter-helper");
const filter_item_type_1 = require("../model/filter-item-type");
const Subject_1 = require("rxjs/Subject");
const operators_1 = require("rxjs/operators");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
const idm_me_client_js_1 = require("@synisys/idm-me-client-js");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const reporting_category_value_loader_1 = require("../../../controls/reporting-filter/loader/reporting-category-value-loader");
const reporting_filter_component_1 = require("../../../controls/reporting-filter/reporting-filter.component");
const page_filter_model_1 = require("../model/page-filter-model");
const page_filter_service_1 = require("../service/page-filter.service");
const multilingual_type_helper_1 = require("../../../shared/multilingual-type-helper");
const idm_um_client_js_1 = require("@synisys/idm-um-client-js");
const idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
const Subscription_1 = require("rxjs/Subscription");
let PageFilterViewComponent = class PageFilterViewComponent {
    constructor(classifierService, userService, authenticationService, meCategoriesCommonService, currentLanguageProvider, pathService, activatedRoute, pageFilterService) {
        this.classifierService = classifierService;
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.meCategoriesCommonService = meCategoriesCommonService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.pathService = pathService;
        this.activatedRoute = activatedRoute;
        this.pageFilterService = pageFilterService;
        this.FilterItemType = filter_item_type_1.FilterItemType;
        this.isAutoApplyEnabled = true;
        this.isCardTitleLongerThenToolbarSection = false;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(classifierService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(meCategoriesCommonService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(currentLanguageProvider);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pathService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(authenticationService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(activatedRoute);
        this.onValueChangeSubject$ = new Subject_1.Subject();
        this.subscriptions = new Subscription_1.Subscription();
        this.initOnValueChange();
    }
    set datasetId(datasetId) {
        this._datasetId = datasetId;
        this.initValueLoader();
    }
    get datasetId() {
        return this._datasetId;
    }
    set state(state) {
        this.pageFilterItems = page_filter_state_1.PageFilterState.stateFromJSON(state);
    }
    set title(title) {
        this.filterTitle = multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(title);
    }
    set autoApplyEnabled(autoApplyEnabled) {
        this.isAutoApplyEnabled = autoApplyEnabled !== "" ? autoApplyEnabled : true; // This is for backward compatibility, old reports doesn't have property
    }
    ngOnDestroy() {
        this.pageFilterService.removeFilter(this.componentId);
        this.subscriptions.unsubscribe();
    }
    ngOnInit() {
        this.constructFilterItems();
    }
    ngAfterViewInit() {
        if (this.pageBuilderToolbarSection && this.pageBuilderToolbarTitle) {
            let toolbarTitleMarginRight = 16;
            this.isCardTitleLongerThenToolbarSection = this.pageBuilderToolbarSection.nativeElement.offsetWidth === this.pageBuilderToolbarTitle.nativeElement.offsetWidth + toolbarTitleMarginRight;
        }
    }
    resetState() {
        this.filterItems = this.preparePageFilterItems(true);
        this.onFiltersChange();
    }
    applyState() {
        this.onValueChangeSubject$.next();
    }
    initOnValueChange() {
        this.subscriptions.add(this.onValueChangeSubject$.asObservable()
            .pipe(operators_1.debounceTime(2000))
            .subscribe(() => {
            this.constructFilters();
        }));
    }
    initValueLoader() {
        if (this.datasetId) {
            this.loadPaths()
                .then((paths) => {
                this.valueLoader = new reporting_category_value_loader_1.ReportingCategoryValueLoader(this.classifierService, this.userService, this.authenticationService, this.meCategoriesCommonService, this.currentLanguageProvider, paths);
            })
                .catch((err) => {
                console.error("Failed with the following error: %o", err);
            });
        }
    }
    loadPaths() {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(this._datasetId);
        return this.pathService.getPaths(this._datasetId)
            .then((paths) => {
            let availablePaths = new Map();
            reporting_filter_component_1.ReportingFilterComponent.extractAvailablePaths(paths.categoryPaths, availablePaths);
            reporting_filter_component_1.ReportingFilterComponent.extractAvailablePaths(paths.measurePaths, availablePaths);
            return availablePaths;
        })
            .catch((err) => {
            console.error("Failed with the following error: %o", err);
            return Promise.reject(err);
        });
    }
    constructFilters() {
        const pageId$ = this.pageId ? of_1.of(this.pageId) : this.activatedRoute.params.pipe(operators_1.take(1), operators_1.map(params => params["pageId"]));
        pageId$.subscribe((pageId) => {
            this.pageId = pageId;
            let filteredItems = this.filterItems
                .map((filterItem) => filterItem.getFilterTreeDto())
                .filter((filterItem) => filterItem !== null);
            let filters = null;
            if (filteredItems.length > 0) {
                filters = filteredItems.reduce((filters, filterItem) => {
                    return idm_reporting_service_client_js_1.FilterDtoBuilder.and(filters, filterItem);
                });
            }
            this.onFiltersChange(filters, this.pageId);
        });
    }
    onFiltersChange(filters, pageId) {
        if (filters) {
            this.pageFilterService.setFilter(new page_filter_model_1.PageFilterModel(this.componentId, this.datasetId, filters, pageId));
        }
        else {
            this.pageFilterService.removeFilter(this.componentId);
        }
    }
    constructFilterItems() {
        this.filterItems = this.preparePageFilterItems();
        this.constructFilters();
    }
    preparePageFilterItems(reset) {
        // In case when auto apply is enabled we need to bind 'valueChangeSubject' to each of filter item to observe all changes
        // otherwise changes only will be applied by button
        const onValueChangeSubject$ = this.isAutoApplyEnabled ? this.onValueChangeSubject$ : null;
        return page_filter_helper_1.convertPageFilterItemsToFilterItems(this.pageFilterItems, onValueChangeSubject$, reset);
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PageFilterViewComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PageFilterViewComponent.prototype, "componentId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], PageFilterViewComponent.prototype, "datasetId", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PageFilterViewComponent.prototype, "state", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PageFilterViewComponent.prototype, "title", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], PageFilterViewComponent.prototype, "autoApplyEnabled", null);
__decorate([
    core_1.ViewChild('pageBuilderToolbarSection'),
    __metadata("design:type", core_1.ElementRef)
], PageFilterViewComponent.prototype, "pageBuilderToolbarSection", void 0);
__decorate([
    core_1.ViewChild('pageBuilderToolbarTitle'),
    __metadata("design:type", core_1.ElementRef)
], PageFilterViewComponent.prototype, "pageBuilderToolbarTitle", void 0);
PageFilterViewComponent = __decorate([
    core_1.Component({
        
        selector: 'sis-page-filter-view',
        template: require('./page-filter-view.component.html'),
        styles: [require('./page-filter-view.component.css')]
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        cellCount: 12,
        groups: [
            {
                identity: "ReportingControls",
                name: "Reporting Controls",
                nameMessageKey: "reporting.controls.group.name",
            },
        ],
        settings: {
            main: page_filter_builder_component_1.PageFilterBuilderComponent,
            central: page_filter_component_1.PageFilterComponent
        },
        template: `<sis-page-filter-view 
                    [id]="controlId" 
                    [componentId]='%{componentId}' 
                    [state]='%{state}' 
                    [datasetId]='%{datasetId}'
                    [title]='%{title}'
                    [autoApplyEnabled]='%{autoApplyEnabled}'></sis-page-filter-view>`,
        iconInfo: "filter",
        name: "Filter",
        nameKey: "reporting.controls.page-filter.widget.label",
        height: 150
    }),
    __param(7, core_1.Optional()),
    __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
        idm_um_client_js_1.UserService,
        idm_authentication_client_js_1.AuthenticationService,
        idm_me_client_js_1.CommonServicesProviderService,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_dataset_service_client_js_1.PathService,
        router_1.ActivatedRoute,
        page_filter_service_1.PageFilterService])
], PageFilterViewComponent);
exports.PageFilterViewComponent = PageFilterViewComponent;
//# sourceMappingURL=page-filter-view.component.js.map